import React from "react";
import styled from "styled-components";
import "./App.css";
import ceremonyImage from "./Images/Ceremony.png";
import dogImage from "./Images/Dog.png";
import gardenPartyImage from "./Images/GardenParty.png";
import headerImage from "./Images/Header.png";
import wineDancersImage from "./Images/WineDancers.png";

const TimelineContainer = styled.div`
  width: 100vw;
  height: 100%;
  min-height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
  padding: 0 2rem 0 2rem;
  background-color: #f5e9dd;
`;

const TimelineWrapper = styled.div`
  background-color: rgb(255, 246, 237);
  backdrop-filter: blur(5px);
  border-radius: 0px;
  border: 1px solid rgba(104, 79, 79, 0.2);
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
  display: flex;
  flex-direction: column;
  padding: 2rem 2rem 0 2rem;
`;

const TimelineTitle = styled.h1`
  font-family: "Monsieur La Doulaise", cursive;
  font-size: 6vmin;
  color: #333;
  text-align: center;
  margin-bottom: 2rem;
  margin-top: 0;
  flex-shrink: 0;
`;

const TimelineList = styled.div`
  position: relative;
  flex: 1;
  padding-top: 1rem;

  &::before {
    content: "";
    position: absolute;
    left: 50%;
    top: 0;
    bottom: 0;
    width: 2px;
    background: #333;
    transform: translateX(-50%);

    @media (max-width: 768px) {
      left: 20px;
    }
  }
`;

const TimelineItem = styled.div`
  position: relative;
  margin-bottom: 3rem;
  display: flex;
  align-items: center;
  width: 100%;

  &:nth-child(odd) {
    flex-direction: row;

    @media (max-width: 768px) {
      flex-direction: row;
      padding-left: 60px;
    }
  }

  &:nth-child(even) {
    flex-direction: row-reverse;

    @media (max-width: 768px) {
      flex-direction: row;
      padding-left: 60px;
    }
  }
`;

const TimelineImage = styled.img`
  width: calc(50% - 30px);
  height: auto;
  max-height: 200px;
  object-fit: contain;

  @media (max-width: 768px) {
    display: none;
  }
`;

const TimelineContent = styled.div`
  padding: 1.5rem;
  width: calc(50% - 30px);
  position: relative;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const TimelineCircle = styled.div`
  width: 20px;
  height: 20px;
  background: #333;
  border-radius: 50%;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  border: 4px solid rgb(255, 246, 237);

  @media (max-width: 768px) {
    left: 20px;
    transform: translateX(-50%);
  }
`;

const DayNumber = styled.span`
  font-family: "Monsieur La Doulaise", cursive;
  font-size: 2rem;
  color: #333;
  display: block;
  margin-bottom: 0.25rem;
`;

const DayDate = styled.span`
  font-family: "IM Fell English", serif;
  font-size: 0.9rem;
  color: #888;
  display: block;
  margin-bottom: 0.25rem;
`;

const EventTitle = styled.h3`
  font-family: "IM Fell English", serif;
  font-size: 1.2rem;
  color: #333;
  margin: 0 0 0.75rem 0;
  font-style: italic;
`;

const EventDescription = styled.p`
  font-family: "IM Fell English", serif;
  font-size: 1rem;
  color: #444;
  margin: 0;
  line-height: 1.5;
`;

const Timeline = () => {
  const events = [
    {
      day: "Day 1",
      date: "Monday 28th June",
      title: "Arrival & Welcome",
      description:
        "Guests arrive throughout the day and settle into the château. The evening brings everyone together for the first time over a welcome dinner in the courtyard.",
      image: headerImage,
    },
    {
      day: "Day 2",
      date: "Tuesday 29th June",
      title: "A Day to Explore",
      description:
        "The day is yours to fill. We'll share a list of suggestions closer to the date — vineyard tours, truffle hunting experiences, cycling through the vines, and more. Activities are entirely optional; equally valid is a long morning by the pool with nowhere to be.",
      image: dogImage,
    },
    {
      day: "Day 3",
      date: "Wednesday 30th June",
      title: "Into the Villages",
      description:
        "The countryside around the château is dotted with some of the most beautiful medieval villages in France. Vézelay is practically on your doorstep, Avallon a short drive beyond, and Noyers-sur-Serein is well worth the detour. Wednesday also happens to be market day in Beaune — exceptional cheese, bread worth crossing borders for, and wine that barely needs to travel.",
      image: gardenPartyImage,
    },
    {
      day: "Day 4",
      date: "Thursday 1st July",
      title: "Pool Party",
      description:
        "Music, sunshine, something cold to drink, and the best company. Consider this the last hurrah before the main event.",
      image: wineDancersImage,
    },
    {
      day: "Day 5",
      date: "Friday 2nd July",
      title: "The Wedding",
      description: "The day itself!",
      image: ceremonyImage,
    },
    {
      day: "Day 6",
      date: "Saturday 3rd July",
      title: "Recovery",
      description:
        "A slow morning with no agenda. Another opportunity to explore, revisit Beaune, or simply find a quiet corner of the château and stay there. The day is yours.",
      image: dogImage,
    },
    {
      day: "Day 7",
      date: "Sunday 4th July",
      title: "Farewell Dinner",
      description:
        "One last evening together before the week draws to a close. A dinner to raise a final glass, swap stories from the week, and say the kind of goodbyes.",
      image: wineDancersImage,
    },
    {
      day: "Day 8",
      date: "Monday 5th July",
      title: "Checkout",
      description:
        "A slow start, last coffees in the courtyard, and the road home. Checkout 10am.",
      image: headerImage,
    },
  ];

  return (
    <TimelineContainer>
      <TimelineWrapper>
        <TimelineTitle>Order of Events</TimelineTitle>
        <TimelineList>
          {events.map((event, index) => (
            <TimelineItem key={index}>
              <TimelineCircle />
              <TimelineContent>
                <DayNumber>{event.day}</DayNumber>
                <DayDate>{event.date}</DayDate>
                <EventTitle>{event.title}</EventTitle>
                <EventDescription>{event.description}</EventDescription>
              </TimelineContent>
              <TimelineImage src={event.image} alt={event.title} />
            </TimelineItem>
          ))}
        </TimelineList>
      </TimelineWrapper>
    </TimelineContainer>
  );
};

export default Timeline;
